<div class="layout-shell relative flex h-dvh min-h-dvh overflow-hidden bg-blue-50/60 dark:bg-gray-800">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <div
    class="layout-content flex min-w-0 flex-1 flex-col overflow-hidden"
    [class.mobile-sidebar-obscured]="isMobileSidebarOpen()"
    [attr.inert]="isContentInert() ? '' : null"
    [attr.aria-hidden]="isContentInert() ? 'true' : null"
  >
    <!-- Header -->
    <app-header class="layout-header w-full"></app-header>

    <!-- Notificaciones de plataforma -->
    <app-system-notification-banner></app-system-notification-banner>

    <main class="relative flex-1 overflow-y-auto" data-pull-refresh-container>
      @if (globalLoadingService.isContentLoading()) {
        <app-loading></app-loading>
      }

      <div class="flex min-h-full justify-center ">
        <div
          class="w-full rounded-lg px-1 pb-[calc(0.75rem+var(--app-safe-bottom)+var(--app-browser-chrome-offset))] pt-2 sm:px-3 sm:pb-[calc(1rem+var(--app-safe-bottom)+var(--app-browser-chrome-offset))] sm:pt-2.5"
          [class.overflow-y-auto]="!(modalService.isOpen$ | async)"
          [class.overflow-hidden]="modalService.isOpen$ | async"
        >
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>
  </div>
</div>
